require("-!/app/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader!sass-loader!/app/node_modules/bootstrap-sass-loader/bootstrap-sass-styles.loader.js!/app/src/theme/bootstrap.config.prod.js");
require("-!/app/node_modules/bootstrap-sass-loader/bootstrap-sass-scripts.loader.js!/app/src/theme/bootstrap.config.prod.js");


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-sass-loader/index.loader.js!./src/theme/bootstrap.config.prod.js
// module id = 1836
// module chunks = 0